export const searchAddress = async (search) => {
  const splitInput = search.split(' ').join('+').trim()
  return await fetch(`https://api-adresse.data.gouv.fr/search/?q=${splitInput}`)
}